import React from 'react';

import { Image } from 'generated/graphql';

import Card from '@material-ui/core/Card';

import ShowroomLayerMedia from 'components/Showroom/Layer/Media';

import { useStyles } from './styles';

export type ComponentProps = {
	file: Image;
	index: number;
};

const ShowroomZoom = (props: ComponentProps) => {
	const { file, index } = props;

	const classes = useStyles();

	return (
		<Card className={classes.imageItemCard} key={`${file.mediaType}_${file.cloudinaryId}_${index}_card`}>
			<ShowroomLayerMedia file={file} index={index} imageStyle={classes.imageItemImg} position="center" />
		</Card>
	);
};

export default React.memo(ShowroomZoom);
